import { render, staticRenderFns } from "./market-item-orders-table-item.vue?vue&type=template&id=b7facbf2&scoped=true"
import script from "./market-item-orders-table-item.vue?vue&type=script&lang=js"
export * from "./market-item-orders-table-item.vue?vue&type=script&lang=js"
import style0 from "./market-item-orders-table-item.vue?vue&type=style&index=0&id=b7facbf2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7facbf2",
  null
  
)

export default component.exports